module.exports = __webpack_public_path__ + "img/img13.d78d71d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img13.png
// module id = 253
// module chunks = 0